import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  ContainerImage,
  Image,
} from './styles';

const ImageComponent = (props) => {
  const {
    text,
    imageName,
    marginHeader,
  } = props;

  return (
    <ContainerImage marginHeader={marginHeader}>
      <Image src={`/images/${_.capitalize(imageName)}.png`} />
      {text}
    </ContainerImage>
  );
};

ImageComponent.propTypes = {
  text: PropTypes.string,
  imageName: PropTypes.string,
  marginHeader: PropTypes.bool,
};

ImageComponent.defaultProps = {
  text: '',
  imageName: '',
  marginHeader: false,
};

export default ImageComponent;
